import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { ClientTypeItem } from '../../types';
import { formatNumber, CLIENT_TYPE_LABELS } from '../../constants/nginx-sites';
import { cn } from '../../lib/utils';

interface ClientTypeBreakdownProps {
  data: ClientTypeItem[];
}

// Data visualization colors - not theme-adaptive
const CLIENT_TYPE_COLORS: Record<string, string> = {
  customer: '#22c55e',
  bot: '#f59e0b',
  scanner: '#ef4444',
  monitor: '#3b82f6',
  unknown: '#6b7280',
};

const CLIENT_TYPE_BADGE_CLASSES: Record<string, string> = {
  customer: 'bg-green-500',
  bot: 'bg-amber-500',
  scanner: 'bg-red-500',
  monitor: 'bg-blue-500',
  unknown: 'bg-gray-500',
};

export function ClientTypeBreakdown({ data }: ClientTypeBreakdownProps) {
  if (!data || data.length === 0) return null;

  return (
    <Card>
      <CardHeader>
        <CardTitle>Tipo de Cliente</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        {/* Stacked bar */}
        <div className="w-full h-6 rounded-full overflow-hidden flex bg-muted">
          {data.map((item) => (
            <div
              key={item.clientType}
              className="h-full transition-all"
              style={{
                width: `${item.percentage}%`,
                backgroundColor: CLIENT_TYPE_COLORS[item.clientType] || '#6b7280',
              }}
              title={`${CLIENT_TYPE_LABELS[item.clientType] || item.clientType}: ${item.percentage.toFixed(1)}%`}
            />
          ))}
        </div>
        {/* Legend rows */}
        <div className="space-y-2">
          {data.map((item) => (
            <div key={item.clientType} className="flex items-center justify-between text-sm">
              <div className="flex items-center gap-2">
                <span
                  className={cn(
                    'w-3 h-3 rounded-full shrink-0',
                    CLIENT_TYPE_BADGE_CLASSES[item.clientType] ?? 'bg-gray-500'
                  )}
                />
                <span>{CLIENT_TYPE_LABELS[item.clientType] || item.clientType}</span>
              </div>
              <div className="flex items-center gap-4 text-muted-foreground">
                <span>{formatNumber(item.count)} req</span>
                <span>{formatNumber(item.visitors)} vis</span>
                <span className="w-12 text-right">{item.percentage.toFixed(1)}%</span>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
